const getCartVariantsAtLimit = async () : Promise<string[]> => {
  try {
    const res = await fetch('/cart/?view=stock-check');
    const ret = await res.json();
    return ret
  } catch (e) {
    console.info(e)
    return []
  }
}
export default getCartVariantsAtLimit